import React from 'react';

import { Deliverables } from './section/Deliverables';
import {
  CreditAgreement,
  CreditAgreementFullArtifactWipConfigType,
} from 'packages/creditAgreements/ui/types';

/**
 * Deliverable-config section of a Backup Servicing (BUS) deal — renders only the
 * recurring-date deliverables of the underlying artifact.
 *
 * Prop-compatible with the other artifact bodies so it drops into the shared
 * client WIP editor via its `ArtifactComponent` seam; the BUS Settings hub mounts
 * it as the "Deliverable Config" section. Saves round-trip the whole artifact
 * JSON, so editing just this section needs no backend change.
 */
// organizationId is part of the shared artifact-body signature but unused here
// (deliverables don't need it); omitting it keeps the component assignable to the
// ArtifactComponent type the WIP editor injects.
type BusDeliverableConfigArtifactProps = {
  creditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
};

export const BusDeliverableConfigArtifact = ({
  creditAgreementFullArtifact,
  wipConfig,
}: BusDeliverableConfigArtifactProps): React.ReactElement => {
  const { deliverables } = creditAgreementFullArtifact;

  return <Deliverables deliverables={deliverables} wipConfig={wipConfig} />;
};
